import styled, { css } from 'styled-components';

const CustomIMG = styled.img`
  ${({ size }) => size === 'normal' && css`
    height: 48px;
    width: 48px;
  `}

  ${({ size }) => size === 'medium' && css`
    height: 54px;
    width: 54px;
  `}
`;

export default CustomIMG;
